export default __webpack_public_path__ + "static/media/sample-line-isometric.7e7cd825.svg";